import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

// import Util from '@/helper/Utility.js';

/**
 * @method apiGetPDPAVersion
 * @method apiGetPDPAContent
 */
 export default {
     config: function () {
        return Vue.bzbsConfig;
     },
     /**
      * Return PDPA version
      */
     apiGetPDPAVersion: function () {
        var appId = this.config().client_id;
        var url = `${this.config().bzbsBlobUrl}/pdpaconsent/${appId}/version`;
        return BzbsApi.connectBzbsGetBlob(url);
     },
     /**
      * Return PDPA contents.
      * @param {String} contentType Terms, privacy, etc..
      * @param {Number} version PDPA content version
      * @param {Number} language PDPA language code.
      */
     apiGetPDPAContent: function (contentType, version, language) {
        var appId = this.config().client_id;
        var url = `${this.config().bzbsBlobUrl}/pdpaconsent/${appId}/${contentType}/${version}/${language}.txt`;
        return BzbsApi.connectBzbsGetBlob(url);
     },
     /**
      * Get current user accepted version.
      * @param {string} token
      */
     apiGetUserPDPA: function (token) {
        var url = `${this.config().bzbsUrl}/consent`;
        return BzbsApi.connectBzbsGet(url, token);
     },
     /**
      * Update user accepted version.
      * @param {string} token
      * @param {number} termVersion
      * @param {number} privacyVersion
      */
     apiUpdateUserPDPA: function (token, params) {
        // var params = {
        //     termandcondition: termVersion,
        //     dataprivacy: privacyVersion,
        // };
        // params = Util.cleanObjectEmptyStr(params);

        var url = `${this.config().bzbsUrl}/consent`;
        return BzbsApi.connectBzbsPost(url, token, params);

     },
      apiGetCookieContent: function (contentType, version, language) {
         var appId = this.config().client_id;
         var url = `${this.config().bzbsBlobUrl}/pdpaconsent/${appId}/${contentType}/${version}/${language}.json`;
         return BzbsApi.connectBzbsGetBlob(url);
      },

      apiSaveCookie: function (token, cookies) {
         let params = {
            necessaryCookies: cookies,
            functionalCookies: cookies,
         }
         var url = `${this.config().bzbsUrl}/consent`;
         return BzbsApi.connectBzbsPost(url, token, params);
      },
 }
